module.exports = __webpack_public_path__ + "images/prototype-projects-bg-231eac824f0bcab7fe216f7dd62ab7fa.png";